export default "__VITE_ASSET__BVBR2_Zl__"